var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ padding: _vm.defaultStyle ? '0 0 15px 20px' : '' })},[_c('img',{attrs:{"box-sizing":"content-box","src":_vm.GLOBAL.baseURL + 'rest/ezcomp/barcode/encode?type=qrcode&format=svg&scale=1.5&data=' + _vm.text,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }